import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import AppDialog from "~/shared/ui/AppDialog";
import { useNotify } from "~/shared/ui/feedback/SnackbarProvider";
import { showDoctorBank, updateBank } from "~/services/antecipebackoffice/doctors";

const EMPTY = { bank_name: "", account_number: "", bank_agency: "", pix: "" };

const EditDoctorBankModal = ({ open, setOpen, handleClose, idDoctor, doctorName, readOnly = false }) => {
  const notify = useNotify();
  const [bank, setBank] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    showDoctorBank(idDoctor).then(
      ({ data }) =>
        alive &&
        setBank({
          bank_name: data.bank_name,
          account_number: data.account_number,
          bank_agency: data.bank_agency,
          pix: data.pix,
        }),
      () => alive && setError("Não foi possível carregar os dados bancários.")
    );
    return () => {
      alive = false;
    };
  }, [idDoctor]);

  const close = (e) => {
    if (saving) return;
    if (typeof handleClose === "function") handleClose(e);
    setOpen(false);
  };
  const set = (field) => (e) => setBank((b) => ({ ...b, [field]: e.target.value }));

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      await updateBank(idDoctor, bank);
      setSaving(false);
      setOpen(false);
      notify({ severity: "success", message: "Banco Atualizado com Sucesso!" });
    } catch (e) {
      setSaving(false);
      setError("Erro ao atualizar banco, por favor preencha todos os campos obrigatórios!");
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={close}
      size="sm"
      busy={saving}
      title="Dados Bancários"
      context={`Médico: ${doctorName}`}
      actions={
        <>
          <Button onClick={close} disabled={saving} sx={{ color: "text.primary" }}>
            {readOnly ? "Fechar" : "Cancelar"}
          </Button>
          {!readOnly && (
            <LoadingButton variant="contained" loading={saving} onClick={save}>
              Atualizar dados bancários
            </LoadingButton>
          )}
        </>
      }
    >
      <Box
        component="fieldset"
        disabled={readOnly}
        sx={{
          border: 0,
          p: 0,
          m: 0,
          minWidth: 0,
          display: "grid",
          gap: 2,
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        }}
      >
        <TextField
          disabled={readOnly}
          required
          label="Banco"
          value={bank.bank_name || ""}
          onChange={set("bank_name")}
          sx={{ gridColumn: "1 / -1" }}
        />
        <TextField disabled={readOnly} required label="Agencia" value={bank.bank_agency || ""} onChange={set("bank_agency")} />
        <TextField
          disabled={readOnly}
          required
          label="Número da conta"
          value={bank.account_number || ""}
          onChange={set("account_number")}
        />
        <TextField disabled={readOnly} label="Pix" value={bank.pix || ""} onChange={set("pix")} sx={{ gridColumn: "1 / -1" }} />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </AppDialog>
  );
};

export default EditDoctorBankModal;
